/**
 * ProjectResourceHeader Component
 *
 * Displays project identification information with a navigation button.
 * Used at the top of the Gestão de Recursos page.
 *
 * Design specs:
 * - Height: 116px (content + padding)
 * - Background: #15203C
 * - Border radius: 20px
 * - Padding: 40px
 * - Title: 24px Bold
 * - Subtitle: 14px Regular with semibold highlights
 * - Button: Primary (#7846FF), 161px width, 50px height
 */

import { Button } from "@/components/ui/button";
import { ProjectResourceInfo } from "@/types/gestao-recursos.interface";

interface ProjectResourceHeaderProps {
  projectInfo: ProjectResourceInfo;
  onGoToProject?: () => void;
}

export function ProjectResourceHeader({
  projectInfo,
  onGoToProject,
}: ProjectResourceHeaderProps) {
  return (
    <div className="bg-[#15203C] rounded-lg p-4">
      <div className="flex items-start justify-between gap-4">
        {/* Project Information */}
        <div className="flex flex-col gap-1">
          {/* Title */}
          <h2 className="text-lg font-bold text-white">
            Recursos do Projeto - {projectInfo.nome}
          </h2>

          {/* Metadata */}
          <div className="flex items-center gap-2 text-xs text-[#D1D1D1]">
            <span>
              Número Salic:{" "}
              <span className="font-semibold text-[#F6F6F6]">
                {projectInfo.salicNumber}
              </span>
            </span>
            <span>
              Produtora:{" "}
              <span className="font-semibold text-[#F6F6F6]">
                {projectInfo.produtora} | {projectInfo.cnpj}
              </span>
            </span>
          </div>
        </div>

        {/* Navigation Button */}
        <Button
          onClick={onGoToProject}
          size="sm"
          className="bg-[#7846FF] hover:bg-[#9b6fff] text-[#F5F2FF] shrink-0"
        >
          Ir para Projeto
        </Button>
      </div>
    </div>
  );
}
